import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LangProvider } from "./i18n/LangContext";
import { Navbar } from "./sections/Navbar";
import { Hero } from "./sections/Hero";
import { Marquee } from "./sections/Marquee";
import { Trust } from "./sections/Trust";
import { Coach } from "./sections/Coach";
import { Audiences } from "./sections/Audiences";
import { Services } from "./sections/Services";
import { Process } from "./sections/Process";
import { Online } from "./sections/Online";
import { Premium } from "./sections/Premium";
import { Testimonials } from "./sections/Testimonials";
import { FAQ } from "./sections/FAQ";
import { Contact } from "./sections/Contact";
import { Footer } from "./sections/Footer";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";

const Home = () => {
  useEffect(() => {
    document.title = "LionPerformance — Elite Sports Psychology & High Performance Coaching";
  }, []);

  return (
    <main data-testid="home-page" className="bg-black text-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <Marquee />
      <Trust />
      <Coach />
      <Audiences />
      <Services />
      <Process />
      <Online />
      <Premium />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <LangProvider>
      <div className="App">
        {/* Global SVG filter to strip the baked-in black background from the LionPerformance PNG logo. Referenced via filter: url(#lp-remove-black) */}
        <svg
          width="0"
          height="0"
          style={{ position: "absolute", pointerEvents: "none" }}
          aria-hidden="true"
        >
          <defs>
            <filter id="lp-remove-black" colorInterpolationFilters="sRGB">
              <feColorMatrix
                type="matrix"
                values="1 0 0 0 0
                        0 1 0 0 0
                        0 0 1 0 0
                        1 1 1 0 -0.05"
              />
            </filter>
          </defs>
        </svg>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
            },
          }}
        />
      </div>
    </LangProvider>
  );
}

export default App;
